"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var Team =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(Team, _Record);

  function Team() {
    (0, _classCallCheck2.default)(this, Team);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Team).apply(this, arguments));
  }

  return Team;
}((0, _immutable.Record)({
  id: undefined,
  name: '',
  memberIds: (0, _immutable.Set)()
}, 'Team'));

var _default = Team;
exports.default = _default;
module.exports = exports.default;